import { apiClient } from '../client'
import type {
  AppNotification,
  NotificationPreference,
  SetNotificationPreferenceRequest,
  UnreadCountResponse,
} from '@milliswift/types'

/**
 * In-app notifications (services/notify).
 *
 * `list` supports `?unread=true` for the dropdown and `limit` for truncation;
 * unread-count exists separately because the header badge polls it on a page
 * where rendering the full list would be wasteful.
 */
export const notifyApi = {
  list: (options: { unread?: boolean; limit?: number } = {}) =>
    apiClient
      .get<AppNotification[]>('/notifications', {
        params: {
          unread: options.unread ? 'true' : undefined,
          limit: options.limit,
        },
      })
      .then((r) => r.data),

  unreadCount: () =>
    apiClient.get<UnreadCountResponse>('/notifications/unread-count').then((r) => r.data),

  markRead: (id: string) =>
    apiClient.post(`/notifications/${id}/read`).then(() => undefined),

  markAllRead: () => apiClient.post('/notifications/read-all').then(() => undefined),

  preferences: () =>
    apiClient.get<NotificationPreference[]>('/notification-preferences').then((r) => r.data),

  setPreference: (data: SetNotificationPreferenceRequest) =>
    apiClient.put<NotificationPreference>('/notification-preferences', data).then((r) => r.data),
}
